module.exports = __webpack_public_path__ + "assets/edb69dd39e379f528a332fcd5b6d66e9.svg";